import { render, staticRenderFns } from "./ElectAi.vue?vue&type=template&id=9485f976&scoped=true"
import script from "./ElectAi.vue?vue&type=script&lang=js"
export * from "./ElectAi.vue?vue&type=script&lang=js"
import style0 from "./ElectAi.vue?vue&type=style&index=0&id=9485f976&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9485f976",
  null
  
)

export default component.exports